<template>
<div class="container">

    <header class="container__header">

        <h1>Pakkeliste</h1>

    </header>

    <div class="container__body container__body--md">

        <section class="data-list">

            <header class="col-12 flex--space padding-b-25 margin-b-25 border-b">

                <h1>Ordre</h1>

                <section class="select-sm">

                    <ws-select :options="productsForSelector" emptytext="Vælg produkt" :use-null="true" v-model="product" @input="getOrdersForProduct"></ws-select>

                </section>

            </header>

            <div class="item" v-for="order in orders">

                <div class="icon">

                    <i class="icon--lg fas fa-inbox"></i>

                </div>

                <div class="content">

                    <h1>{{order.product_title}}</h1>

                    <ul>

                        <li>Ordre: {{order.id}}, Dato: {{order.deliver_at | moment('DD/MM/YYYY')}}</li>

                    </ul>

                </div>

                <div class="link">

                    <router-link :to="{name:'order.search.order', params:{order:order.id}}">Se ordre</router-link>

                </div>

            </div>

            <h4 v-if="orders.length === 0">Ingen ordrer fundet</h4>

        </section>

    </div>

</div>

</template>

<script>
export default {
    name: 'order',
    data(){
        return {
            product:null,
            products:[],
            orders:[],
        };
    },
    computed:{
        productsForSelector(){
            const products = {}
            this.products.forEach(item => {
                products[item.id] = item.title;
            });
            return products;
        }
    },
    methods:{
        getAllProducts(){
            axios.get('/api/admin/product').then(response => {
                this.products = response.data.data;
                this.getAllOrders();
            })
        },
        getAllOrders(){
            axios.get('/api/admin/order/delivery').then(response => {
                this.orders = response.data.data;
            })
        },
        getOrdersForProduct(){
            this.orders = [];
            axios.get(`/api/admin/order/delivery/product/${this.product}`).then(response => {
                this.orders = response.data.data;
            })
        },
    },
    created(){
        this.getAllProducts();
    }
}
</script>
